
export const dataPurchaseType = [
    {
        id: "self",
        name: "Для себе"
    },
    {
        id: "friend",
        name: "Для друга"
    }
]

